import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { Injector, Output } from '@angular/core';
import { Input } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { AddressServiceService } from 'src/app/core/services/address-service.service';
import { isNullOrEmpty, laaSFormatString } from 'src/app/core/utils/common-functions';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { CommonDataService } from 'src/app/core/services/common-data.service';

@Component({
  selector: 'laas-address-management',
  templateUrl: './address-management.component.html',
  styleUrls: ['./address-management.component.scss']
})
export class AddressManagementComponent extends SessionBaseComponent implements OnInit {
  currentIndex: number;
  currentDeliveryType: string;
  currentAddress: string;
  currentCompany: string;
  currentConsigneeKey: string;
  currentConsigneeName: string;
  currentDoNo: string;
  currentFacility: string;
  currentDo: any;
  confirmType: number;
  usingShipToAddress: boolean;

  isAirportDisabled: boolean;
  isLoading: boolean;

  insertForm: any;
  countryOptions: any[];
  validateHKFacilitySetting: any[] = [];

  // 相同地址DO批次正規化：每次切換到一筆DO就先查好同客戶代碼+公司+地址、還沒正規化的相同地址DO，
  // 讓使用者隨時可以點開勾選要不要一併套用；真正送出跟主流程的「確認」合併成同一個動作。
  showSameAddressDialog = false;
  sameAddressCandidates: any[] = [];
  selectedSameAddressDoNos: string[] = [];
  sameAddressLookbackDays = 0;


  @Output() onClose = new EventEmitter<boolean>();
  @Output() onEditAddress = new EventEmitter<any>();
  @Input() doNos!: any[];
  @Input() display: boolean;

  recommendations: any[];
  chooseAddress: number;

  maxChars = 60;
  maxCharsForNormalize = 135;

  chooseOptionWording: string = "";

  constructor(
    injector: Injector,
    private addressServiceService: AddressServiceService,
    private facilityService: FacilityService,
    private fb: FormBuilder,
    private commonDataService:CommonDataService
  ) {
    super(injector);
    this.display = false;
    this.currentIndex = 0;
    this.currentDeliveryType = "";
    this.currentDoNo = "";
    this.currentFacility = "";
    this.confirmType = 1;
    this.currentCompany = "";
    this.currentAddress = "";
    this.currentConsigneeKey = "";
    this.currentConsigneeName = "";
    this.recommendations = [];
    this.chooseAddress = 0;
    this.countryOptions = [];
    this.usingShipToAddress = false;
    this.isAirportDisabled = true;
    this.isLoading = false;
  }

  createInsertForm(): void {
    this.insertForm = {
      countrySelected: "",
      districtOptions: [{
        label: this.chooseOptionWording,
        value: ""
      }],
      cityOptions: [{
        label: this.chooseOptionWording,
        value: ""
      }],
      airportOptions: [{
        label: this.chooseOptionWording,
        value: ""
      }],
      city: "",
      districtSelected: "",
      localAddress: "",
      engAddress: ""
    }
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.commonDataService.getAppCsmSetting('HKFacilitySetting').subscribe({
      next:(option:any)=>{
        this.validateHKFacilitySetting = option.appCsmSettingDetailList;
      }
    });

    this.translateService.get("Common.Message.ChooseOption").subscribe({
      next: result => {
        this.chooseOptionWording = result;
        this.createInsertForm();
      }
    });

    this.addressServiceService.getCountryOptions().subscribe({
      next: result => {
        this.countryOptions = [...result].map((x: any) => {
          return {
            label: `${x.countryName} (${x.countryEnName})`,
            value: x.countryCode
          }
        });

        this.countryOptions.unshift({
          label: this.chooseOptionWording,
          value: ''
        });
      },
      complete: () => {

      }
    })

  }

  showDialog(event: any): void {
    this.addressServiceService.checkUsingShipToAddress(this.doNos[0].doNo).subscribe({
      next: result => {
        this.usingShipToAddress = result;
        console.info("checkUsingShipToAddress.next: this.usingShipToAddress=", JSON.stringify(this.usingShipToAddress));
      },
      complete: () => {
        console.info("checkUsingShipToAddress.complete: this.usingShipToAddress=", JSON.stringify(this.usingShipToAddress));

        this.confirmType = 1;

        var firstDo = this.doNos[0];
        console.log(`firstDo=${JSON.stringify(firstDo)}`); // TODO Remove: 確認倉別
        this.currentDoNo = firstDo.doNo;
        this.currentIndex = 1;
        this.currentDo = firstDo;
        this.currentFacility = firstDo.facility;
        console.log(`this.currentFacility=${this.currentFacility}`); // TODO Remove: 確認倉別
        this.currentCompany = this.getCurrentCompany();
        this.currentAddress = this.getCurrentAddress();
        this.currentConsigneeKey = firstDo.consigneeKey;
        this.currentConsigneeName = firstDo.consigneeCompany;
        this.currentDeliveryType = firstDo.deliveryType;
        this.selectedSameAddressDoNos = [];
        this.loadSameAddressCandidates();
        this.getRecommendation();
      }
    })
  }

  private getRecommendation(): void {
    this.isLoading = true;
    this.addressServiceService.getRecommendationAddress({
      consigneeKey: this.currentConsigneeKey,
      address: this.currentAddress,
      deliveryType: this.currentDeliveryType,
      company: this.currentCompany
    }).subscribe({
      next: result => {
        this.recommendations = result;
        this.recommendations.forEach(async (rec: any) => {
          console.log(`rec=${JSON.stringify(rec)}`); // TODO Remove: 確認Airport
          if (this.checkAirportNeedMaintenance(rec.Airport)) {
            this.isAirportDisabled = false;
          }
          console.log(`this.isAirportDisabled=${this.isAirportDisabled}`); // TODO Remove: 確認Airport

          if (!isNullOrEmpty(rec.Country)) {
            rec.cityOptions = await this.getCityOptions(rec.Country);
            rec.cityOptions.unshift({
              label: this.chooseOptionWording,
              value: ""
            });

            rec.City = isNullOrEmpty(rec.City) ? null : rec.City.toString();
          }

          if (!isNullOrEmpty(rec.City)) {
            rec.airportOptions = await this.getAirportOptions(rec.City);
            rec.airportOptions.unshift({
              label: this.chooseOptionWording,
              value: ""
            });

            rec.districtOptions = await this.getAssignmentDistrict(rec.Country, rec.City);
            rec.districtOptions.unshift({
              label: this.chooseOptionWording,
              value: ""
            });
          }

        });

        if (result.length > 0) {
          this.chooseAddress = [...result].map((x: any) => {
            return x.SeqNo;
          })[0];
        }
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  private getCurrentAddress(): string {
    console.info("getCurrentAddress: this.usingShipToAddress=", JSON.stringify(this.usingShipToAddress));
    var doObj = this.currentDo;
    var address = `${this.handleAddress(doObj.deliveryToAddress2)} ${this.handleAddress(doObj.deliveryToAddress3)} ${this.handleAddress(doObj.deliveryToAddress4)} ${this.handleAddress(doObj.deliveryToAddress5)}`;

    if (address.trim() == "" || this.usingShipToAddress) {
      address = `${this.handleAddress(doObj.consigneeAddress2)} ${this.handleAddress(doObj.consigneeAddress3)} ${this.handleAddress(doObj.consigneeAddress4)} ${this.handleAddress(doObj.consigneeAddress5)}`;
      console.info('use consigneeAddress(shipToAddress) as currentAddress');
    }

    return address.trim();
  }

  private getCurrentCompany(): string {
    console.info("getCurrentCompany: this.usingShipToAddress=", JSON.stringify(this.usingShipToAddress));
    var doObj = this.currentDo;
    var company = "";
    var address = `${this.handleAddress(doObj.deliveryToAddress2)} ${this.handleAddress(doObj.deliveryToAddress3)} ${this.handleAddress(doObj.deliveryToAddress4)} ${this.handleAddress(doObj.deliveryToAddress5)}`;

    if (address.trim() == "" || this.usingShipToAddress) {
      company = `${this.handleAddress(doObj.consigneeAddress1)}`;
      console.info('use consigneeAddress(shipToAddress) as currentCompany');
    } else {
      company = `${this.handleAddress(doObj.deliveryToAddress1)}`;
    }

    return company.trim();
  }

  private handleAddress(address?: string): string {
    if (isNullOrEmpty(address)) {
      return "";
    }
    return address == null ? "" : address;
  }

  private async getAssignmentDistrict(country: string, city: string): Promise<any[]> {
    var assignemnetOptions: any[] = [];
    try {
      assignemnetOptions = await this.addressServiceService.getAssignmentDistrict(country, city);
    } catch {
      this.toastService.error('get assignment district occur error');
    }
    return new Promise(resolve => {
      resolve(
        assignemnetOptions.map((x: any) => {
          return {
            label: `${x.AssignmentDistrictId}-${x.DistrictName}`,
            value: x.AssignmentDistrictId
          }
        })
      )
    });
  }

  private async getAirportOptions(city: string): Promise<any[]> {
    var aiportOptions: any[] = [];
    try {
      aiportOptions = await this.facilityService.getAirPortOptionsAsync(city);
    } catch {
      this.toastService.error('get airport occur error');
    }
    return new Promise(resolve => {
      resolve(
        aiportOptions.map((x: any) => {
          return {
            label: x.optionDesc,
            value: x.optionCode
          }
        })
      )
    });
  }

  private async getCityOptions(country: string): Promise<any[]> {
    var cityOptions: any[] = [];
    try {
      cityOptions = await this.addressServiceService.getCityOptions(country);
    } catch {
      this.toastService.error('get assignment district occur error');
    }
    return new Promise(resolve => {
      resolve(
        cityOptions.map((x: any) => {
          return {
            label: `${x.Name} (${x.EnName})`,
            value: x.SeqNo.toString()
          }
        })
      )
    });
  }

  hideDialog(event: any): void {
    this.recommendations = [];
    this.showSameAddressDialog = false;
    this.sameAddressCandidates = [];
    this.selectedSameAddressDoNos = [];
    this.onClose.emit(this.display);
  }

  insertAddress(event: any): void {
    var inputObj = {
      address: this.currentAddress,
      consigneeKey: this.currentConsigneeKey,
      userId: this.userProfile.loginAccount,
      source: {
        seqNo: null,
        groupId: null,
        consigneeKey: this.currentConsigneeKey,
        consigneeName: this.currentConsigneeName,
        normalizationCompanyName: this.currentCompany,
        country: this.dontSaveEmpty(this.insertForm.countrySelected),
        localAddress: this.dontSaveEmpty(this.insertForm.localAddress),
        engAddress: this.dontSaveEmpty(this.insertForm.engAddress),
        assignmentDistrictId: this.dontSaveEmpty(this.insertForm.districtSelected),
        city: this.dontSaveEmpty(this.insertForm.city),
        deliveryToLocalName: this.dontSaveEmpty(this.insertForm.deliveryToLocalName),
        deliveryToEngName: this.dontSaveEmpty(this.insertForm.deliveryToEngName),
        airport: this.dontSaveEmpty(this.insertForm.airport)
      }
    };
    console.log(`insertAddress.inputObj=${JSON.stringify(inputObj)}`);
    this.saveAddressWithSameAddressConfirm(inputObj);
  }

  mergeAddress(event: any): void {
    var chooseAddress = this.recommendations.filter((x: any) => {
      return x.SeqNo == this.chooseAddress;
    });

    if (chooseAddress.length > 0) {
      var inputObj = {
        address: this.currentAddress,
        consigneeKey: this.currentConsigneeKey,
        userId: this.userProfile.loginAccount,
        source: {
          seqNo: chooseAddress[0].SeqNo,
          groupId: chooseAddress[0].GroupId,
          consigneeKey: this.currentConsigneeKey,
          consigneeName: this.currentConsigneeName,
          normalizationCompanyName: this.currentCompany,
          country: this.dontSaveEmpty(chooseAddress[0].Country),
          localAddress: this.dontSaveEmpty(chooseAddress[0].LocalAddress),
          engAddress: this.dontSaveEmpty(chooseAddress[0].EngAddress),
          assignmentDistrictId: this.dontSaveEmpty(chooseAddress[0].AssignmentDistrictId),
          city: this.dontSaveEmpty(chooseAddress[0].City),
          deliveryToLocalName: this.dontSaveEmpty(chooseAddress[0].DeliveryToLocalName),
          deliveryToEngName: this.dontSaveEmpty(chooseAddress[0].DeliveryToEngName),
          airport: this.dontSaveEmpty(chooseAddress[0].Airport),
        }
      };
      console.log(`mergeAddress.inputObj=${JSON.stringify(inputObj)}`);
      this.saveAddressWithSameAddressConfirm(inputObj);
    } else {
      this.toastService.info(this.translateService.instant('AddressMaintain.ChooseAddress'));
    }
  }

  // 有勾選相同地址DO時，先把「會一起被套用幾筆」講清楚再送出，避免使用者按下確認才發現影響範圍比預期大
  private saveAddressWithSameAddressConfirm(inputObj: any): void {
    if (this.selectedSameAddressDoNos.length === 0) {
      this.saveAddress(inputObj);
      return;
    }

    this.confirmationService.confirm({
      header: this.translateService.instant('Address.SameAddress.ConfirmApplyHeader'),
      message: laaSFormatString(
        this.translateService.instant('Address.SameAddress.ConfirmApplyMessage'),
        [String(this.selectedSameAddressDoNos.length)]
      ),
      icon: 'pi pi-info-circle',
      accept: () => this.saveAddress(inputObj),
      reject: () => { return; }
    });
  }

  private async dplCheck(dplCheckObj: any): Promise<boolean> {
    var isok = true;
    try {
      var dplResult = await this.addressServiceService.dplCheck(dplCheckObj);
      if (dplResult.flag == "E") {
        this.toastService.warn(dplResult.message);
        isok = false;
      }
    } catch (err: any) {
      isok = false;
      this.toastErrorMessage(err.error);
    }

    return isok;
  }

  private isNotAbleToSave(inputObj: any): boolean {

    let isNotAbleToSaveFlag = false;

    if (this.isLocalDeliveryType() && isNullOrEmpty(inputObj.source.localAddress)) {
      this.toastService.error(this.translateService.instant('AddressMaintain.RejectToUpdateEmptyLocalAddress'));
      console.log("isNotAbleToSave: deliveryType is Local and localAddress is null");
      isNotAbleToSaveFlag = true;
    }

    if (this.isExportDeliveryType() && isNullOrEmpty(inputObj.source.engAddress)) {
      this.toastService.error(this.translateService.instant('AddressMaintain.RejectToUpdateEmptyEngAddress'));
      console.log("isNotAbleToSave: deliveryType is Export and engAddress is null");
      isNotAbleToSaveFlag = true;
    }

    if (this.isLocalDeliveryType() && isNullOrEmpty(inputObj.source.deliveryToLocalName)) {
      this.toastService.error(this.translateService.instant('AddressMaintain.RejectToUpdateEmptyDeliveryToLocalName'));
      console.log("isNotAbleToSave: deliveryType is Local and deliveryToLocalName is null");
      isNotAbleToSaveFlag = true;
    }

    if (this.isExportDeliveryType() && isNullOrEmpty(inputObj.source.deliveryToEngName)) {
      this.toastService.error(this.translateService.instant('AddressMaintain.RejectToUpdateEmptyDeliveryToEngName'));
      console.log("isNotAbleToSave: deliveryType is Export and dilveryToEngName is null");
      isNotAbleToSaveFlag = true;
    }

    if (isNullOrEmpty(inputObj.source.assignmentDistrictId)) {
      this.toastService.error(this.translateService.instant('AddressMaintain.RejectToUpdateEmptyAssignmentDistrictId'));
      console.log("isNotAbleToSave: assignmentDistrictId is null");
      isNotAbleToSaveFlag = true;
    }

    if (isNullOrEmpty(inputObj.source.city)) {
      this.toastService.error(this.translateService.instant('AddressMaintain.RejectToUpdateEmptyCity'));
      console.log("isNotAbleToSave: city is null");
      isNotAbleToSaveFlag = true;
    }

    if (isNullOrEmpty(inputObj.source.country)) {
      this.toastService.error(this.translateService.instant('AddressMaintain.RejectToUpdateEmptyCountry'));
      console.log("isNotAbleToSave: country is null");
      isNotAbleToSaveFlag = true;
    }

    if (this.checkAirportNeedMaintenance(inputObj.source.airport)) {
      this.toastService.error(this.translateService.instant('AddressMaintain.MaintainAirport'));
      console.log("isNotAbleToSave: airport need maintenance");
      isNotAbleToSaveFlag = true;
    }

    if (inputObj.source.engAddress && inputObj.source.engAddress.length > 135) {
      this.toastService.error(this.translateService.instant('AddressMaintain.AddressLimited'));
      console.log("isNotAbleToSave: engAddress length is too long");
      isNotAbleToSaveFlag = true;
    }

    return isNotAbleToSaveFlag;
  }

  private removeParenthesesAndContent(str: string) : string {
    return str.replace(/\([^)]*\)/g, '');
  }

  private isExportDeliveryType(): boolean {
    return this.removeParenthesesAndContent(this.currentDeliveryType).toUpperCase().includes('EXPORT')
  }

  private isLocalDeliveryType(): boolean {
    return this.removeParenthesesAndContent(this.currentDeliveryType).toUpperCase().includes('LOCAL')
  }

  private isRelationalAddressSelectionMode(): boolean {
    return this.confirmType === 1;
  }

  private isNewAddressInsertionMode(): boolean {
    return this.confirmType === 2;
  }

  private async saveAddress(inputObj: any): Promise<void> {

    if (this.isNotAbleToSave(inputObj)) return;

    this.isLoading = true;

    if (!isNullOrEmpty(inputObj.source.engAddress)) {
      var dplCheckObj = {
        doNo: this.currentDoNo,
        country: inputObj.source.country,
        address: inputObj.source.engAddress,
        companyName: inputObj.source.consigneeName
      };

      var isok = await this.dplCheck(dplCheckObj);
      if (isok == false) {
        this.isLoading = false;
        return;
      }
    }

    inputObj.source.city = (inputObj.source.city == 0) ? null : inputObj.source.city;
    this.addressServiceService.mergeAddress(inputObj).subscribe({
      next: result => {
        if (result.result == "OK") {
          if (this.checkMergeAddressResult(result)) {
            // update Do
            var updateObj = {
              doNo: this.currentDoNo,
              localAddress: this.dontSaveEmpty(inputObj.source.localAddress),
              engAddress: this.dontSaveEmpty(inputObj.source.engAddress),
              assignmentDistrictId: this.dontSaveEmpty(inputObj.source.assignmentDistrictId),
              city: this.dontSaveEmpty(inputObj.source.city),
              country: this.dontSaveEmpty(inputObj.source.country),
              groupId: result.groupId
            }
            console.log(`saveAddress.updateObj=${JSON.stringify(updateObj)}`);

            this.addressServiceService.updateDoAddress(updateObj).subscribe({
              next: result => {
                this.currentDo.normalizationAddress = result.normalizationAddress;
                this.currentDo.assignmentDistrictId = result.assignmentDistrictId;
                this.currentDo.normalizationCity = result.city;
                this.currentDo.normalizationCountry = result.country;
                this.currentDo.normalizationGroupId = updateObj.groupId;
                this.onEditAddress.emit(this.currentDo);
                if (this.selectedSameAddressDoNos.length > 0) {
                  // 這筆DO自己確認完成，緊接著把同一個groupId/地址套用給使用者剛剛勾選的相同地址DO
                  this.applyToSameAddressDeliveryOrders(updateObj);
                } else {
                  this.nextAddress();
                  this.isLoading = false;
                }
              }
            })
          }
        }
      }
    });
  }

  private checkMergeAddressResult(result: any): boolean {
    if (isNullOrEmpty(result.groupId)) {
      this.toastService.error(this.translateService.instant('AddressMaintain.RejectToUpdateEmptyNormalizationGroupID'));
      console.log("checkMergeAddressResult: RejectToUpdateEmptyNormalizationGroupID is null");
      return false;
    }
    console.log("checkMergeAddressResult: all check pass");
    return true;
  }

  private nextAddress(): void {
    if (this.currentIndex == this.doNos.length) {
      //over close dialog
      this.display = false;
    } else {
      //next Do
      this.currentIndex++;
      this.addressServiceService.checkUsingShipToAddress(this.doNos[this.currentIndex].doNo).subscribe({
        next: result => {
          this.usingShipToAddress = result;
          console.info("nextAddress.checkUsingShipToAddress.next: this.usingShipToAddress=", JSON.stringify(this.usingShipToAddress));
        },
        complete: () => {
          console.info("nextAddress.checkUsingShipToAddress.complete: this.usingShipToAddress=", JSON.stringify(this.usingShipToAddress));
          var nextDo = this.doNos[this.currentIndex];
          this.currentDoNo = nextDo.doNo;
          this.currentDo = nextDo;
          this.currentAddress = this.getCurrentAddress();
          this.currentConsigneeKey = nextDo.consigneeKey;
          this.currentConsigneeName = nextDo.consigneeCompany;
          this.confirmType = 1;
          this.selectedSameAddressDoNos = [];
          this.loadSameAddressCandidates();
          this.getRecommendation();
        }
      })
    }
  }

  /**
   * 切換到一筆新的DO時就先查好同客戶代碼+收件公司+地址、還沒正規化過、
   * 且不在目前這批doNos裡的相同地址DO，讓使用者隨時能自己點開查看/套用，不強迫當下決定。
   * 查詢失敗就當作沒有相同地址DO，不影響主流程。
   */
  private loadSameAddressCandidates(): void {
    this.sameAddressCandidates = [];
    this.sameAddressLookbackDays = 0;
    const excludeDoNos = this.doNos.map((d: any) => d.doNo);
    this.addressServiceService.findSameAddressUnnormalizedDeliveryOrders(this.currentDoNo, excludeDoNos).subscribe({
      next: (result: any) => {
        this.sameAddressLookbackDays = result?.lookbackDays || 0;
        this.sameAddressCandidates = result?.deliveryOrders || [];
      },
      error: () => {
        this.sameAddressCandidates = [];
      }
    });
  }

  // Badge文字裡的「近N天內」要跟後端AppCsmSetting實際設定的回看天數一致，不能寫死
  getSameAddressBadgeText(): string {
    return laaSFormatString(
      this.translateService.instant('Address.SameAddress.Badge'),
      [String(this.sameAddressLookbackDays)]
    );
  }

  // 使用者在相同地址DO面板裡按「確定」關閉面板時觸發，記住這次選了哪幾筆，等主流程「確認」時一併套用；
  // [display]是單向繫結，面板自己把display設false只會關掉它自己畫面上的樣子，
  // 父層的showSameAddressDialog一定要在這裡一起reset，不然下次change detection會被單向繫結強制拉回開啟狀態
  onSameAddressSelectionChanged(doNos: string[]): void {
    this.selectedSameAddressDoNos = doNos || [];
    this.showSameAddressDialog = false;
  }

  // 主確認按鈕文字：有勾選相同地址DO時，直接把後果講在按鈕上，不用讓使用者自己記得
  getConfirmButtonLabel(): string {
    if (this.selectedSameAddressDoNos.length > 0) {
      return laaSFormatString(
        this.translateService.instant('Address.SameAddress.ConfirmButtonWithCount'),
        [String(this.selectedSameAddressDoNos.length)]
      );
    }
    return this.translateService.instant('Common.Button.Confirm');
  }

  // currentDo自己的地址confirm成功後，緊接著把同一個groupId/地址套用到使用者勾選的相同地址DO上，
  // 完成(不論成功失敗)才繼續nextAddress()，讓使用者一次動作就看到完整結果
  private applyToSameAddressDeliveryOrders(updateObj: any): void {
    const payload = {
      groupId: updateObj.groupId,
      localAddress: updateObj.localAddress,
      engAddress: updateObj.engAddress,
      assignmentDistrictId: updateObj.assignmentDistrictId,
      city: updateObj.city,
      country: updateObj.country,
      doNos: this.selectedSameAddressDoNos
    };
    this.addressServiceService.batchApplyNormalizedAddress(payload).subscribe({
      next: (result: any) => {
        this.showSameAddressApplyResult(result);
        this.isLoading = false;
        this.nextAddress();
      },
      error: (err: any) => {
        this.toastErrorMessage(err.error ?? err);
        this.isLoading = false;
        this.nextAddress();
      }
    });
  }

  private showSameAddressApplyResult(result: any): void {
    const successCount = result?.successDoNos?.length ?? 0;
    const failures = result?.failures ?? [];

    if (successCount > 0) {
      this.toastService.success(laaSFormatString(this.translateService.instant('Address.SameAddress.Result.Success'), [String(successCount)]));
    }
    if (failures.length > 0) {
      const summary = laaSFormatString(this.translateService.instant('Address.SameAddress.Result.Failure'), [String(failures.length)]);
      const detail = failures.map((f: any) => `${f.doNo}: ${f.reason}`).join('\n');
      this.toastService.error(`${summary}\n${detail}`);
    }
  }

  async insertFormCityChange(event: any): Promise<void> {
    this.insertForm.airport = "";

    if (!isNullOrEmpty(this.insertForm.countrySelected)) {
      this.insertForm.districtOptions = await this.getAssignmentDistrict(this.insertForm.countrySelected, this.insertForm.city);
      this.insertForm.districtOptions.unshift({
        label: this.chooseOptionWording,
        value: ""
      });
    }

    if (!isNullOrEmpty(this.insertForm.city)) {
      this.insertForm.airportOptions = await this.getAirportOptions(this.insertForm.city);
      this.insertForm.airportOptions.unshift({
        label: this.chooseOptionWording,
        value: ""
      });
    }
  }

  async insertFormCountryChange(event: any): Promise<void> {
    this.insertForm.districtSelected = "";
    this.insertForm.city = "";
    this.insertForm.airport = "";

    if (!isNullOrEmpty(this.insertForm.countrySelected)) {
      this.insertForm.districtOptions = await this.getAssignmentDistrict(this.insertForm.countrySelected, this.insertForm.city);
      this.insertForm.districtOptions.unshift({
        label: this.chooseOptionWording,
        value: ""
      });

      this.insertForm.cityOptions = await this.getCityOptions(this.insertForm.countrySelected);
      this.insertForm.cityOptions.unshift({
        label: this.chooseOptionWording,
        value: ""
      });
    }
  }

  async mergeCountryChange(event: any, address: any): Promise<void> {
    address.AssignmentDistrictId = "";
    address.Airport = "";
    if (!isNullOrEmpty(address.Country)) {
      address.districtOptions = await this.getAssignmentDistrict(address.Country, address.City);
      address.districtOptions.unshift({
        label: this.chooseOptionWording,
        value: ""
      });

      address.cityOptions = await this.getCityOptions(address.Country);
      address.cityOptions.unshift({
        label: this.chooseOptionWording,
        value: ""
      });
    }
  }

  async mergeCityChange(event: any, address: any): Promise<void> {
    address.Airport = "";
    if (!isNullOrEmpty(address.City)) {
      address.districtOptions = await this.getAssignmentDistrict(address.Country, address.City);
      address.districtOptions.unshift({
        label: this.chooseOptionWording,
        value: ""
      });

      address.airportOptions = await this.getAirportOptions(address.City);
      address.airportOptions.unshift({
        label: this.chooseOptionWording,
        value: ""
      });
    }
  }

  private dontSaveEmpty(original: string): string | null {
    return isNullOrEmpty(original) ? null : original;
  }

  public checkAirportNeedMaintenance(airport: string): boolean {
    if (this.isExportDeliveryType() && isNullOrEmpty(airport)) {
      if (!this.validateHKFacilitySetting || !this.validateHKFacilitySetting.length) {
        return false;
      }
      return this.validateHKFacilitySetting.some(
        x => x.setupValue === this.currentFacility.toUpperCase()
      );
    }
    return false;
  }

  copyToClipboard(text: string): void {
    if (!text) {
      return;
    }
    navigator.clipboard.writeText(text).then(() => {
      this.toastService.success(this.translateService.instant('Common.Toast.CopySuccess'));
    }).catch(() => {
      this.toastService.error(this.translateService.instant('Common.Toast.CopyFail'));
    });
  }

}
